/// <amd-module name="SuiteCommerce.GiftCertificate.ValueCheck.Form.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.ValueCheck.Form.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.Instrumentation", "SuiteCommerce.GiftCertificate.Main.Configuration", "SuiteCommerce.GiftCertificate.ValueCheck.Configuration", "SuiteCommerce.GiftCertificate.ValueCheck.Model", "value_check_form.tpl"], function (require, exports, Backbone_1, Instrumentation_1, Main_Configuration_1, ValueCheck_Configuration_1, ValueCheck_Model_1, template) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ValueCheckFormView = exports.ValueCheckModelSubmittingErrorEvent = exports.ValueCheckModelSubmittedEvent = void 0;
    exports.ValueCheckModelSubmittedEvent = 'ValueCheckModelSubmitted';
    exports.ValueCheckModelSubmittingErrorEvent = 'ValueCheckModelSubmittingErrorEvent';
    var ValueCheckFormView = /** @class */ (function (_super) {
        __extends(ValueCheckFormView, _super);
        function ValueCheckFormView(options) {
            var _this = _super.call(this, options) || this;
            _this.showFeedbackMessages = true;
            _this.events = {
                'click button[data-action="gift-certificate-save"]': 'saveGiftCertificate',
                'click button[data-action="gift-certificate-get"]': 'getGiftCertificateDetail',
                'mousedown a[data-action="gift-certificate-save"]': 'setupNavigationToMyAccount',
                'submit form': 'submitForm',
            };
            _this.application = options.application;
            _this.template = template;
            _this.showFeedbackMessages = options.showFeedbackMessages;
            _this.showAddToMyAccountButtonAsLink =
                options.showAddToMyAccountButtonAsLink;
            _this.displayedInShopping = options.displayedInShopping || false;
            _this.displayedInCheckout = options.displayedInCheckout || false;
            _this.displayedInMyAccount = options.displayedInMyAccount || false;
            Backbone_1.Validation.bind(_this);
            if (_this.model.get('giftcertcode')) {
                _this.model.set('hasDefaultCode', true);
            }
            return _this;
        }
        ValueCheckFormView.prototype.submitForm = function (event) {
            event.preventDefault();
        };
        ValueCheckFormView.prototype.getGiftCertificateDetail = function (event) {
            var _this = this;
            if (this.isValidModel()) {
                this.$('.gift-certificate-balance-main-form-button').attr('disabled', 'disabled');
                var requestObj = this.model.getGiftCertificateData();
                requestObj.done(function () {
                    if (_this.model.get('status') === ValueCheck_Model_1.GiftCertificateStatus.active ||
                        _this.model.get('status') === ValueCheck_Model_1.GiftCertificateStatus.expired) {
                        _this.cleanValidationErrors();
                    }
                    else {
                        _this.displayError(_this.model.validation.giftcertcode.msg);
                    }
                    _this.$('.gift-certificate-balance-main-form-button').removeAttr('disabled');
                    _this.sendLogForCheckGiftCertificateBalance();
                });
                requestObj.then(null, function (error) {
                    return _this.triggerException(error);
                });
            }
            else {
                this.displayError(this.model.validation.giftcertcode.msg);
            }
        };
        ValueCheckFormView.prototype.saveGiftCertificate = function (code) {
            var _this = this;
            var giftCertificateCode = typeof code === 'string'
                ? code
                : this.$('[name="giftcertcode"]').val().toString().trim();
            if (this.isValidModel(giftCertificateCode)) {
                var requestObj = void 0;
                this.$('.gift-certificate-balance-main-form-save-button').attr('disabled', 'disabled');
                this.cleanValidationErrors();
                requestObj = this.model.save({
                    giftcertcode: giftCertificateCode,
                });
                requestObj.done(function (response) {
                    _this.model.trigger(exports.ValueCheckModelSubmittedEvent, response);
                    _this.$('.gift-certificate-balance-main-form-save-button').removeAttr('disabled');
                    _this.$('[name="giftcertcode"]').val('');
                    _this.sendLogForGiftCertificateSaved();
                });
                requestObj.then(null, function (error) {
                    _this.triggerException(error);
                    if (error.responseJSON.error === 'ERROR_GIFT_CERTIFICATE_INVALID' ||
                        error.responseJSON.error === 'ERROR_GIFT_CERTIFICATE_INACTIVE') {
                        _this.displayError(_this.model.validation.giftcertcode.msg);
                    }
                });
                return requestObj;
            }
            this.displayError(this.model.validation.giftcertcode.msg);
        };
        ValueCheckFormView.prototype.triggerException = function (error) {
            this.$('.gift-certificate-balance-main-form-save-button').removeAttr('disabled');
            this.$('.gift-certificate-balance-main-form-button').removeAttr('disabled');
            this.model.trigger(exports.ValueCheckModelSubmittingErrorEvent, error);
        };
        ValueCheckFormView.prototype.setupNavigationToMyAccount = function (event) {
            event.preventDefault();
            if (this.isValidModel()) {
                var link = this.$el.find(event.target);
                link.data('touchpoint', 'customercenter');
                link.data('hashtag', encodeURIComponent("#/gift-certificates?giftcertcode=".concat(this.model.get('giftcertcode'))));
            }
            else {
                this.displayError(this.model.validation.giftcertcode.msg);
                return false;
            }
        };
        ValueCheckFormView.prototype.isValidModel = function (defaultCode) {
            var giftCertificateCode = this.$('[name="giftcertcode"]').val() || defaultCode;
            if (giftCertificateCode) {
                this.model.set({ giftcertcode: giftCertificateCode.trim() });
            }
            else {
                this.model.set({ giftcertcode: '' });
            }
            this.model.validate(this.model.attributes);
            return this.model.isValid();
        };
        ValueCheckFormView.prototype.displayError = function (message) {
            var placeholder = this.$('[data-type="input-help-text"]');
            this.$('.gift-certificate-balance-main-form-input-field-column').attr('data-validation-error', 'true');
            placeholder.html(message);
        };
        ValueCheckFormView.prototype.cleanValidationErrors = function () {
            this.$('[data-type="input-help-text"]').html('');
            this.$('.gift-certificate-balance-main-form-input-field-column').removeAttr('data-validation-error');
        };
        ValueCheckFormView.prototype.sendLogForCheckGiftCertificateBalance = function () {
            var requestLog = Instrumentation_1.default.getLog('giftCertificateRequestLog');
            var requestLogActivity = 'Click on "Add to my account button"';
            if (this.displayedInShopping) {
                requestLogActivity = 'Check gift certificate balance from Shopping';
            }
            else if (this.displayedInCheckout) {
                requestLogActivity = 'Check gift certificate balance from Checkout';
            }
            else if (this.displayedInMyAccount) {
                requestLogActivity = 'Check gift certificate balance from My Account';
            }
            requestLog.setParameters({
                activity: requestLogActivity,
            });
            requestLog.submit();
        };
        ValueCheckFormView.prototype.sendLogForGiftCertificateSaved = function () {
            var requestLog = Instrumentation_1.default.getLog('giftCertificateRequestLog');
            var requestLogActivity = 'Click on "Add to my account button"';
            if (this.displayedInShopping) {
                requestLogActivity = 'Click on "Add to my account button" from Shopping';
            }
            else if (this.displayedInCheckout) {
                requestLogActivity = 'Click on "Add to my account button" from Checkout';
            }
            else if (this.displayedInMyAccount) {
                requestLogActivity =
                    'Click on "Add to my account button" from My Account';
            }
            requestLog.setParameters({
                activity: requestLogActivity,
            });
            requestLog.submit();
        };
        ValueCheckFormView.prototype.getContext = function () {
            return {
                labelText: ValueCheck_Configuration_1.ValueCheckConfiguration.labelText,
                buttonText: ValueCheck_Configuration_1.ValueCheckConfiguration.buttonText,
                addToMyAccountButtonText: ValueCheck_Configuration_1.ValueCheckConfiguration.saveButtonText,
                placeholderText: ValueCheck_Configuration_1.ValueCheckConfiguration.placeholderText,
                helpText: ValueCheck_Configuration_1.ValueCheckConfiguration.helpText,
                hasHelpText: !!ValueCheck_Configuration_1.ValueCheckConfiguration.helpText,
                invalidCodeMessage: ValueCheck_Configuration_1.ValueCheckConfiguration.invalidCodeMessage,
                inactiveCodeMessage: ValueCheck_Configuration_1.ValueCheckConfiguration.inactiveCodeMessage,
                showAddToMyAccountButtonAsLink: this.showAddToMyAccountButtonAsLink,
                giftCode: this.model.get('giftcertcode'),
                isEnabledAddToMyAccount: Main_Configuration_1.MainConfiguration.enableGiftCertMyAccount,
            };
        };
        ValueCheckFormView.prototype.render = function () {
            this._render();
            if (this.model.get('hasDefaultCode')) {
                this.saveGiftCertificate(this.model.get('giftcertcode'));
            }
            return this;
        };
        return ValueCheckFormView;
    }(Backbone_1.View));
    exports.ValueCheckFormView = ValueCheckFormView;
});
